var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchQuery($event)
                }
              }
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "公司法人" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入公司法人" },
                            model: {
                              value: _vm.queryParam.corporation,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "corporation", $$v)
                              },
                              expression: "queryParam.corporation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "单位" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入单位" },
                            model: {
                              value: _vm.queryParam.name,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "name", $$v)
                              },
                              expression: "queryParam.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "负责人姓名" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入负责人姓名" },
                            model: {
                              value: _vm.queryParam.principalName,
                              callback: function($$v) {
                                _vm.$set(_vm.queryParam, "principalName", $$v)
                              },
                              expression: "queryParam.principalName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { xl: 6, lg: 7, md: 8, sm: 24 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", icon: "search" },
                            on: { click: _vm.searchQuery }
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "reload" },
                            on: { click: _vm.searchReset }
                          },
                          [_vm._v("重置")]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-operator" },
        [
          _c(
            "a-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "customer:add",
                  expression: "'customer:add'"
                }
              ],
              attrs: { type: "primary", icon: "plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v("新增")]
          ),
          _vm.selectedRowKeys.length > 0
            ? _c(
                "a-dropdown",
                {
                  directives: [
                    {
                      name: "has",
                      rawName: "v-has",
                      value: "customer:batchDelete",
                      expression: "'customer:batchDelete'"
                    }
                  ]
                },
                [
                  _c(
                    "a-menu",
                    { attrs: { slot: "overlay" }, slot: "overlay" },
                    [
                      _c(
                        "a-menu-item",
                        { key: "1", on: { click: _vm.batchDel } },
                        [
                          _c("a-icon", { attrs: { type: "delete" } }),
                          _vm._v("删除")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-button",
                    { staticStyle: { "margin-left": "8px" } },
                    [
                      _vm._v(" 批量操作 "),
                      _c("a-icon", { attrs: { type: "down" } })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "ant-alert ant-alert-info",
              staticStyle: { "margin-bottom": "16px" }
            },
            [
              _c("i", {
                staticClass: "anticon anticon-info-circle ant-alert-icon"
              }),
              _vm._v(" 已选择 "),
              _c("a", { staticStyle: { "font-weight": "600" } }, [
                _vm._v(_vm._s(_vm.selectedRowKeys.length))
              ]),
              _vm._v("项\n      "),
              _c(
                "a",
                {
                  staticStyle: { "margin-left": "24px" },
                  on: { click: _vm.onClearSelected }
                },
                [_vm._v("清空")]
              )
            ]
          ),
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              scroll: { x: 1000 },
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
              rowSelection: {
                selectedRowKeys: _vm.selectedRowKeys,
                onChange: _vm.onSelectChange
              }
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "status",
                fn: function(text, record) {
                  return [
                    _c("j-switch", {
                      on: {
                        change: function($event) {
                          return _vm.onSwitchChange(record, $event)
                        }
                      },
                      model: {
                        value: record.status,
                        callback: function($$v) {
                          _vm.$set(record, "status", $$v)
                        },
                        expression: "record.status"
                      }
                    })
                  ]
                }
              },
              {
                key: "emp",
                fn: function(text, record) {
                  return [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handlerShowEmployee(record)
                          }
                        }
                      },
                      [_vm._v(_vm._s(record.num))]
                    )
                  ]
                }
              },
              {
                key: "htmlSlot",
                fn: function(text) {
                  return [_c("div", { domProps: { innerHTML: _vm._s(text) } })]
                }
              },
              {
                key: "imgSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无图片")]
                        )
                      : _c("img", {
                          staticStyle: {
                            "max-width": "80px",
                            "font-size": "12px",
                            "font-style": "italic"
                          },
                          attrs: {
                            src: _vm.getImgView(text),
                            height: "25px",
                            alt: ""
                          }
                        })
                  ]
                }
              },
              {
                key: "fileSlot",
                fn: function(text) {
                  return [
                    !text
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-style": "italic"
                            }
                          },
                          [_vm._v("无文件")]
                        )
                      : _c(
                          "a-button",
                          {
                            attrs: {
                              ghost: true,
                              type: "primary",
                              icon: "download",
                              size: "small"
                            },
                            on: {
                              click: function($event) {
                                return _vm.downloadFile(text)
                              }
                            }
                          },
                          [_vm._v("\n          下载\n        ")]
                        )
                  ]
                }
              },
              {
                key: "action",
                fn: function(text, record) {
                  return _c(
                    "span",
                    {},
                    [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "has",
                              rawName: "v-has",
                              value: "customer:edit",
                              expression: "'customer:edit'"
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.handleEdit(record)
                            }
                          }
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "a-dropdown",
                        [
                          _c(
                            "a",
                            { staticClass: "ant-dropdown-link" },
                            [
                              _vm._v("更多 "),
                              _c("a-icon", { attrs: { type: "down" } })
                            ],
                            1
                          ),
                          _c(
                            "a-menu",
                            { attrs: { slot: "overlay" }, slot: "overlay" },
                            [
                              _c(
                                "a-menu-item",
                                {
                                  directives: [
                                    {
                                      name: "has",
                                      rawName: "v-has",
                                      value: "customer:detail",
                                      expression: "'customer:detail'"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.handleDetail(record)
                                        }
                                      }
                                    },
                                    [_vm._v("详情")]
                                  )
                                ]
                              ),
                              _c(
                                "a-menu-item",
                                {
                                  directives: [
                                    {
                                      name: "has",
                                      rawName: "v-has",
                                      value: "customer:delete",
                                      expression: "'customer:delete'"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "a-popconfirm",
                                    {
                                      attrs: { title: "确定删除吗?" },
                                      on: {
                                        confirm: function() {
                                          return _vm.handleDelete(record.id)
                                        }
                                      }
                                    },
                                    [_c("a", [_vm._v("删除")])]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }
              }
            ])
          })
        ],
        1
      ),
      _c("pre-customer-modal", {
        ref: "modalForm",
        on: { ok: _vm.modalFormOk, handlerNextPage: _vm.handlerNextPage }
      }),
      _c("pre-employee-modal", {
        ref: "employeeModalForm",
        on: { ok: _vm.modalFormOk, handlerLastPage: _vm.handlerLastPage }
      }),
      _c("pre-show-employee-modal", {
        ref: "showEmployeeModalForm",
        on: { ok: _vm.modalFormOk, handlerNextPage: _vm.handlerNextPage }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }